import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * Database's table unique constraint stored in this class.
 */
export var TableUnique = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function TableUnique(options) {
    _classCallCheck(this, TableUnique);
    this["@instanceof"] = Symbol.for("TableUnique");
    /**
     * Columns that contains this constraint.
     */
    this.columnNames = [];
    this.name = options.name;
    this.columnNames = options.columnNames;
    this.deferrable = options.deferrable;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Creates a new copy of this constraint with exactly same properties.
   */
  _createClass(TableUnique, [{
    key: "clone",
    value: function clone() {
      return new TableUnique({
        name: this.name,
        columnNames: _toConsumableArray(this.columnNames),
        deferrable: this.deferrable
      });
    }
    // -------------------------------------------------------------------------
    // Static Methods
    // -------------------------------------------------------------------------
    /**
     * Creates unique from the unique metadata object.
     */
  }], [{
    key: "create",
    value: function create(uniqueMetadata) {
      return new TableUnique({
        name: uniqueMetadata.name,
        columnNames: uniqueMetadata.columns.map(function (column) {
          return column.databaseName;
        }),
        deferrable: uniqueMetadata.deferrable
      });
    }
  }]);
  return TableUnique;
}();